// removed by extract-text-webpack-plugin
module.exports = {"normal":"normal__2dOiw","button":"button__1Y_Se normal__2dOiw","multiple":"multiple__2gOWl normal__2dOiw","input":"input__3138n normal__2dOiw","hidden":"hidden__3Y9pw"};


//////////////////
// WEBPACK FOOTER
// ./components/ChatBot/styles/answer.scss
// module id = AixX
// module chunks = 0